import router from '@/router'
import { getRouteRedirect } from '@/router/helpers'
import { SsoSettings } from '@/types/index'

export default function useSsoPopup() {
  const openSsoPopup = (ssoSettings: SsoSettings) => {
    const url = 'https://' + location.host + ssoSettings.url + getRouteRedirect(router)
    const width = 600
    const height = 700
    const left = window.screen.width / 2 - width / 2
    const top = window.screen.height / 2 - height / 2

    window.open(
      url,
      'saml_login_popup',
      `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes`
    )
  }

  return {
    openSsoPopup
  }
}
